import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import 'moment/min/locales';
@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {

  transform(val: Date): string {
    if (val) {
        if ((new Date(val)).getFullYear() == 1900) {
            return "NA"
        } else {
            var currentLang = localStorage.getItem('lang');
            if (currentLang == "ar") {
                moment.locale('ar-sa');
                return moment(String(val)).format('LL');
            } else {
                moment.locale('en');
                return moment(String(val)).format('LL');
            }
        }
    }else{
        return "";
    }
}

}
